'use strict';

var razorpaycancelApi = require('./razorpayCacelApi.js');
/**
 * Creates and returns the Razorpay checkout options object.
 *
 * @param {string} callbackurl - URL for payment success callback.
 * @param {string} razorpaycancelurl - URL called when payment is canceled or dismissed.
 * @param {Object} data - Contains Razorpay order, site preferences, and customer details.
 * @param {string} razorpayredirecturl - URL to redirect after payment completion or cancel.
 * @returns {Object} Razorpay options object used to initialize the Razorpay checkout.
 */
function createRazorPayOptions(callbackurl, razorpaycancelurl, data, razorpayredirecturl) {
    var razorPayObject = JSON.parse(data.razorPayOptionObject);
    var options = {};
    if (razorPayObject) {
        options = {
            key: data.siteprefvalues.secretKeyID,
            amount: razorPayObject.amount,
            currency: razorPayObject.currency,
            name: data.siteprefvalues.name,
            description: data.siteprefvalues.description,
            image: data.siteprefvalues.images,
            order_id: razorPayObject.id,
            callback_url: callbackurl,
            prefill: {
                name: data.customerProfile.customerName,
                email: data.customerProfile.customeremail,
                contact: data.customerProfile.customerPhoneNo
            },
            notes: {
                address: 'Razorpay Corporate Office'
            },
            modal: {
                ondismiss: function (razorpayData) {
                    razorpaycancelApi.callDismissalHandler(razorpayData, razorpaycancelurl, razorpayredirecturl);
                }
            },
            theme: {
                color: '#3399cc'
            }
        };
    }
    return options;
}
module.exports = {
    createRazorPayOptions: createRazorPayOptions
};
